import styled from "styled-components";
import Paper from "@mui/material/Paper";
import { Box, InputBase } from "@mui/material";
import { theme } from "styles/mui-config";
import Button from "@mui/material/Button";

export const StyledMainPaper = styled(Paper)`
  width: 100%;
  height: auto;
  position: relative;
`;

export const StyledDeleteDiv = styled.div`
  width: 36px;
  height: 36px;
  border-bottom-right-radius: 15px;
  border-right: 1px solid #ff7979;
  color: #ff7979;
  border-bottom: 1px solid #ff7979;
  padding: 5px;
  transition: 0.3s;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ff7979;
  cursor: pointer;

  &:hover {
    background-color: #ff7979;
    color: rgba(224, 224, 224);
  }
`;

export const StyledMainDivFlex = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const StyledMainDivImageAndInfo = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledMainDivCount = styled.div`
  width: 100px;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 15px;
`;

export const StyledInput = styled(InputBase)`
  height: 10px !important;
  font-size: 16px !important;
  width: 40px;
  text-align: center;
  & * {
    text-align: center;
    border-bottom: 2px solid ${theme.palette.primary.dark} !important;
  }
`;
export const AddProductWrapper = styled(Box)`
  width: 100px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:nth-child(2) {
    background-color: white;
  }
`;
export const IconWrapper = styled(Box)`
  background-color: ${theme.palette.primary.main};
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  border-radius: 5px;
  padding: 1px;
  cursor: pointer;
  &:hover {
    background-color: ${theme.palette.primary.dark};
  }
`;

export const StyledImageDiv = styled.div`
  width: 200px;
  height: 200px;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 1020px) {
    width: 160px;
    height: 160px;
  }

  @media screen and (max-width: 485px) {
    width: 140px;
    height: 140px;
  }
`;

export const StyledProductInfoDiv = styled.div`
  flex-direction: column;
  margin-right: 20px;
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 4px;
`;

export const StyledProductTitle = styled.p`
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  color: rgb(0, 74, 94);
  font-family: Avini;
  padding-left: 44px;

  @media screen and (max-width: 580px) {
    font-size: 19px;
  }

  @media screen and (max-width: 533px) {
    font-size: 15px;
  }
`;

export const StyledProductPrice = styled.p`
  color: rgb(0, 154, 194);
  font-style: normal;
  font-weight: 400;
  font-size: 18px;

  @media screen and (max-width: 533px) {
    font-size: 15px;
  }

  @media screen and (max-width: 401px) {
    font-size: 13px;
    margin-bottom: 66px;
  }
`;

export const StyledMainFixedPaper = styled(Paper)`
  width: 100%;
  height: 120px;
  position: fixed;
  bottom: 0;
  right: 0;
  display: flex;
  direction: rtl;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: white;
  z-index: 1100;
  box-sizing: border-box;
`;

export const StyledMainFixedDiv = styled.div`
  width: 100%;
  height: 100%;
  // border: 1px solid red;
`;

export const StyledMainFixedDiv2 = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;

  @media screen and (max-width: 599px) {
    width: auto;
    height: auto;
  }
`;

export const StyledFixedDivPrice = styled.p`
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  color: rgb(0, 74, 94);
  font-family: Avini;
  margin-top: 0px;
  margin-bottom: 20px;
  @media screen and (max-width: 442px) {
    font-size: 20px;
  }
`;

export const StyledFixedDivDescription = styled.p`
  font-size: 14px;
  color: #4a4a4a;
  margin-top: -20px;
  @media screen and (max-width: 442px) {
    font-size: 10px;
  }
`;

export const StyledMainFixedButtonNext = styled(Button)`
  padding: 7px;
  padding-left: 20px;
  padding-right: 20px px;
  background: #4dc488 !important;
  border: 2px solid #4dc488;
  color: white;
  border-radius: 10px;
  width: 130px;
  text-align: center;
  margin: 5px;
  transition: 0.3s;
  margin-left: 20px !important;

  @media screen and (max-width: 602px) {
    width: 110px;
    margin-left: 0px !important;
    margin-bottom: 10px !important;
  }
`;

export const StyledMainFixedButtonDeleteAllProduct = styled(Button)`
  padding: 7px;
  padding-left: 20px;
  padding-right: 20px;
  background: white;
  border: 2px solid #ff4e4e !important;
  color: #ff4e4e !important;
  border-radius: 10px;
  width: 130px;
  display: inline-block;
  margin: 5px;
  transition: 0.3s;

  @media screen and (max-width: 602px) {
    width: 110px;
  }

  &:hover {
    background: #ff4e4e !important;
    color: white !important;
  }
`;
